var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { ChatAutoMessageButton } from './chat-auto-message-button';
import { template, compact, mapValues } from 'lodash';
import { useChat } from '@shapeable/ui';
import { chatMessageSerialize, chatValueIsText, classNames } from '@shapeable/utils';
import { CellLabel, usePageEntity } from '@shapeable/ui';
var cls = classNames('chat-auto-message-menu');
export var ChatAutoMessageMenuDefaultProps = {
  onMessageClick: function () {},
  prompts: [],
  color: 'light'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-items: flex-end;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    gap: ", ";\n    align-items: flex-end;\n  "])), theme.UNIT(3))
});
var TitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", "em;\n    text-transform: none;\n    ", "\n  "], ["\n    font-size: ", "em;\n    text-transform: none;\n    ", "\n  "])), 12 / 16, function (_a) {
    var _color = _a._color;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR(_color !== null && _color !== void 0 ? _color : 'light'));
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: ", "em;\n  "], ["\n    font-size: ", "em;\n  "])), 14 / 16)
});
var ButtonsStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    gap: ", ";\n    align-items: flex-end;\n  "], ["\n    display: flex;\n    flex-direction: row-reverse;\n    flex-wrap: wrap;\n    gap: ", ";\n    align-items: flex-end;\n  "])), theme.UNIT(3))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Title: styled(CellLabel)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Buttons: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  Button: styled(ChatAutoMessageButton)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles)
};
export var ChatAutoMessageMenu = function (props) {
  var className = props.className,
    children = props.children,
    title = props.title,
    color = props.color,
    onMessageClick = props.onMessageClick;
  var prompts = compact(props.prompts);
  var entity = usePageEntity();
  var chat = useChat();
  if (!prompts.length) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Title, {
    _color: color
  }, title), React.createElement(My.Buttons, null, prompts.map(function (prompt) {
    var message = __assign(__assign({
      source: 'user'
    }, prompt), {
      values: mapValues(prompt.values, function (value) {
        if (chatValueIsText(value)) {
          return template(value)({
            entity: entity
          });
        }
        return value;
      })
    });
    var text = chatMessageSerialize(message);
    if (prompt.useColor) {
      message.color = chat.color;
    }
    return React.createElement(My.Button, {
      color: color,
      key: prompt.id,
      onClick: function () {
        onMessageClick === null || onMessageClick === void 0 ? void 0 : onMessageClick(message);
      }
    }, text);
  })));
};
ChatAutoMessageMenu.cls = cls;
ChatAutoMessageMenu.defaultProps = ChatAutoMessageMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;